import React from 'react';
import './AmenidadesArtemisa.scss';
import Slider from '../Slider/Slider';
import { SwiperSlide } from "swiper/react";
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import { useTranslation } from 'react-i18next';

const AmenidadesArtemisa = () => {
  const { t } = useTranslation();

  return (
    <div id="amenidades" className='contenedor_amenidades_artemisa'>
      <div className='amenidades_top_artemisa'>
        <AnimationOnScroll
          duration={2}
          animateOnce={true}
          animateIn='animate__fadeIn'>
          <div className='subtitulo_ame_arte'>
            <h2 dangerouslySetInnerHTML={{ __html: t('amenitiesArtemisa.title') }} />
          </div>
        </AnimationOnScroll>
        <div className='list_ame_artemisa'>
          <div className='colum_list_artemisa'>
            <img src="/assets/Artemisa/svg-icon-alberca.svg" alt={t('amenitiesArtemisa.clubhousePool')} />
            <p>{t('amenitiesArtemisa.clubhousePool')}</p>
          </div>
          <div className='colum_list_artemisa'>
            <img src="/assets/Iconos/Amenidades/svg-icon-juegos-infantiles.svg" alt={t('amenitiesArtemisa.playground')} />
            <p>{t('amenitiesArtemisa.playground')}</p>
          </div>
          <div className='colum_list_artemisa'>
            <img src="/assets/Iconos/Amenidades/svg-icon-lineal.svg" alt={t('amenitiesArtemisa.linearPark')} />
            <p>{t('amenitiesArtemisa.linearPark')}</p>
          </div>
          <div className='colum_list_artemisa'>
            <img src="/assets/Iconos/Amenidades/svg-icon-dogpark.svg" alt={t('amenitiesArtemisa.dogPark')} />
            <p>{t('amenitiesArtemisa.dogPark')}</p>
          </div>
          <div className='colum_list_artemisa'>
            <img src="/assets/Iconos/Amenidades/svg-icon-ciclovia.svg" alt={t('amenitiesArtemisa.cyclingTrack')} />
            <p>{t('amenitiesArtemisa.cyclingTrack')}</p>
          </div>
          <div className='colum_list_artemisa'>
            <img src="/assets/Iconos/Amenidades/svg-icon-coworking.svg" alt={t('amenitiesArtemisa.coworking')} />
            <p>{t('amenitiesArtemisa.coworking')}</p>
          </div>
          <div className='colum_list_artemisa'>
            <img src="/assets/Iconos/Amenidades/svg-icon-area-verde.svg" alt={t('amenitiesArtemisa.greenArea')} />
            <p>{t('amenitiesArtemisa.greenArea')}</p>
          </div>
          <div className='colum_list_artemisa'>
            <img src="/assets/Iconos/Amenidades/svg-icon-padel.svg" alt={t('amenitiesArtemisa.padelCourt')} />
            <p>{t('amenitiesArtemisa.padelCourt')}</p>
          </div>
          <div className='colum_list_artemisa'>
            <img src="/assets/Iconos/Amenidades/svg-icon-picnics.svg" alt={t('amenitiesArtemisa.picnicArea')} />
            <p>{t('amenitiesArtemisa.picnicArea')}</p>
          </div>
          <div className='colum_list_artemisa'>
            <img src="/assets/Iconos/Amenidades/svg-icon-acceso.svg" alt={t('amenitiesArtemisa.dualAccess')} />
            <p>{t('amenitiesArtemisa.dualAccess')}</p>
          </div>
          <div className='colum_list_artemisa'>
            <img src="/assets/Iconos/Amenidades/svg-icon-caseta.svg" alt={t('amenitiesArtemisa.gatehouse')} />
            <p>{t('amenitiesArtemisa.gatehouse')}</p>
          </div>
        </div>
      </div>
      <div id="galeria" className='amenidades_bottom_artemisa'>
        <Slider nav={false} pag={true}>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider_artemisa">
              <img src="./assets/Artemisa/img-parques-artemisa-velasur.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider_artemisa">
              <img src="./assets/Artemisa/img-casa-club-artemisa-velasur.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider_artemisa">
              <img src="./assets/Artemisa/img-aereo-artemida-velasur.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider_artemisa">
              <img src="./assets/Artemisa/img-andadores-artemisa-velasur.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider_artemisa">
              <img src="./assets/Artemisa/img-coworking-artemisa-velasur.jpg" alt="Velasur1" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider_artemisa">
              <img src="./assets/Artemisa/img-trotapista-artemisa-velasur.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
        </Slider>
      </div>
    </div>
  );
}

export default AmenidadesArtemisa;
